import React, { ReactNode } from "react";

const PageHeader = ({ children }: { children: ReactNode }) => {
    return <div className={`ContinueDealerOffer__Header`}>{children}</div>;
};

export { PageHeader };
